module.exports = __webpack_public_path__ + "img/fedex-img1.2666125b.png";